<script src="http://lite.payapp.kr/public/api/payapp-lite.js"></script>

<template>
  <div>
    <div>
      <div
        class="modal fade show"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        v-if="$store.state.userStore.payModal"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                수신 휴대폰번호
              </h5>
            </div>
            <div class="modal-body">
              <div>
                <div>
                  <div>
                    <h6 class="card-inside-title">핸드폰번호</h6>
                    <div class="input-group">
                      <input
                        type="number"
                        class="form-control"
                        v-model="phoneNumber"
                      />
                      <small
                        >입력하신 수신 전화번호로 결제 URL이 전송됩니다. 전송된
                        URL을 클릭하여 결제하시면 됩니다.</small
                      >
                    </div>
                  </div>
                </div>
              </div>
<!--              <form ref="forms" action="https://api.payapp.kr/oapi/apiLoad.html" target="_blank">-->
<!--                <input name="goodname" value="플랜 결제">-->
<!--                <input name="price" value="1000">-->
<!--                <input name="recvphone" value="01093012259">-->
<!--                <input name="feedbackurl" value="http://tools.frients.io/pg/receivePayApp.do">-->
<!--                <input name="var1" value="타입">-->
<!--                <input name="var2" value="ttttt">-->
<!--                <input name="buyerid" value="dsfdws@gmail.com">-->
<!--                <input name="userid" value="dsfdws@gmail.com">-->

<!--              </form>-->





              <!--              <div id="test1111">-->
              <!--                <button-->
              <!--                  id="authModalLoginBtn"-->
              <!--                  type="button"-->
              <!--                  class="btn btn-default"-->

              <!--                  @click="sendPaymentInfo()"-->
              <!--                >-->
              <!--                  발송-->
              <!--                </button>-->
              <!--              </div>-->
              <!-- <h6 class="card-inside-title">라벨</h6>
              <select class="form-control show-tick">
                <option value="">test1</option>
                <option value="">test2</option>
                <option value="">test3</option>
              </select> -->
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-primary"
                @click="doPayment"
              >
                발송
              </button>
              <button type="button" class="btn btn-default" @click="closeModal">
                닫기
              </button>
<!--              <button type="button" @click="payappPay">결제하기</button>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!--<script src="https://lite.payapp.kr/public/api/payapp-lite.js"></script>-->
<!--<script src="//lite.payapp.kr/public/api/payapp-lite.js"></script>-->



<script>
// import PayApp  from "https://lite.payapp.kr/public/api/payapp-lite.js";
// import eventbus from "@/store/modules/devEventBus";
// import "@/store/modules/payment";




export default {
  name: "auth",
  data() {
    return {
      userAuthModal: false,
      saveBtn: false,
      forms: [],
      checkNum: null,

      phoneNumber: "",

      componentType: null,
    };
  },
  computed: {
    trueFalseModal() {
      console.log("ddddddddddddddddddddddddddddddddddddddddddd");
      return this.$store.getters.getPayModal;
    },
  },
  watch: {
    checkOpen() {
      this.setFormsDatas();
    },
  },

  methods: {
    payappPay() {
      console.log("ddd");


      // this.$refs.forms.submit();

      // PayApp.goodname = "test good";
      // PayApp.price = "1000";
      // PayApp.recvphone = "01000000000";
      // PayApp.smsuse = "y";
      // PayApp.redirectpay = "1";
      // PayApp.skip_cstpage = "y";
      // PayApp.call();
    },
    sendPaymentInfo() {
      this.doPayment();

      console.log(this.phoneNumber);
    },

    closeModal() {
      this.$store.dispatch("getPayModal", {
        state: false,
      });
    },

    doPayment() {
      // var PayApp = "";

      if(this.$store.state.userStore.itemPrice == 0){
        this.$store.state.userStore.itemPrice = 120000
      }

      var planType = "";
      if(this.$store.state.userStore.itemPrice == 120000){
        planType = '베이직'
      } else if(this.$store.state.userStore.itemPrice == 320000){
        planType = '스페셜'

      } else if(this.$store.state.userStore.itemPrice == 500000){
        planType = '프리미엄'

      }



      var obj = new Object();
      obj.goodName = "플랜 결제" + planType;
      obj.price = this.$store.state.userStore.itemPrice;
      obj.recvphone =  this.phoneNumber;
      obj.feedbackurl = "http://tools.frients.io/pg/receivePayApp.do";
      obj.var1 = "타입" + planType;
      obj.var2 = this.$store.getters.getUserCode;
      obj.buyerid =  this.$store.state.userStore.userEmail;

      console.log(obj);

      //  api.payapp.kr    https://api.payapp.kr/oapi/apiLoad.html

      if(confirm("결제를 진행하시겠습니까?")) {

        const headers = new Headers();
        headers.append( "Content-Type", "application/json");

        const request = new Request("https://api.payapp.kr/oapi/apiLoad.html",
            {
              method : "POST",
              headers,
              mode : "cors",
              cache : "default"
            })

        const res = fetch(request);
        console.log("결과 :",res)



        // this.$store
        //     .dispatch("paymentRequest", { paths: "https://api.payapp.kr/oapi/apiLoad.html", params: obj })
        //     .then((res) => {
              console.log("trigger input:", res);


              PayApp.setParam('userid','ksacademy');
              PayApp.setParam('shopname','EasyWork');
              PayApp.setParam('goodname',"플랜결제 - Type" + planType );
              PayApp.setParam('price',obj.price);
              PayApp.setParam('recvphone',obj.recvphone);
              PayApp.setParam('reqaddr',1);
              PayApp.setParam('feedbackurl',"http://tools.frients.io/pg/receivePayApp.do");
              PayApp.setParam('var1',"PlanType - " + planType);
              PayApp.setParam('var2',obj.var2);
              PayApp.setParam('buyerid',obj.buyerid);
              PayApp.call();









            //
            // })
            // .catch(() => alert("오류가 발생했습니다."));
        // AprilUtils.sendServer("https://api.payapp.kr/oapi/apiLoad.html", obj, function(data) {
        //   // alert("결제 정보가 핸드폰으로 발송되었습니다. 핸드폰에서 결제를 하시면 플랜이 적용됩니다.");
        //   // document.location.href = "/dashboard.do";
        // });

            // alert("결제 정보가 핸드폰으로 발송되었습니다. 핸드폰에서 결제를 하시면 플랜이 적용됩니다.");
            // document.location.href = "/index.do";
        this.phoneNumber = ""


        this.$store.dispatch("getPayModal", {
          state: false,
          price : 0
        });


      }




      // obj.price = 1000
      // obj.recvphone = '01093012259'
      // obj.feedbackurl = "http://tools.frients.io/pg/receivePayApp.do"
      // obj.var1 = "타입"
      // obj.var2 = this.$store.getters.getUserCode
      // obj.buyerid = this.$store.state.userStore.userEmail
      //
      // var urlencode = require('urlencode');
      // var encoded = urlencode(obj);

      // var options = {
      //   url: 'http://api.payapp.kr/oapi/apiLoad.html',
      //   method: 'POST',
      //   var headers = {
      //     'Accept' : 'text/html,application/xhtml+xml,*/*',
      //     'Host' : 'api.payapp.kr',
      //     'Accept-Language' : 'ko-KR',
      //     'Content-Type' : 'application/x-www-form-urlencoded',
      //   }
      //   body: obj
      // };

      // this.$store
      //   .dispatch("paymentRequest", { paths: "api.payapp.kr", params: obj })
      //   .then((res) => {
      //     console.log("trigger input:", res);
      //   })
      //   .catch(() => alert("오류가 발생했습니다."));

      // function callback(error, response, body) {
      //   if (!error && response.statusCode == 200) {
      //     var qObj2 = queryString.parse(body, '&', '=', { maxKeys: 3 });
      //
      //     /* naxKeys를 여러분의 코드에 맞게 바꾸시길 바랍니다. (무조건 1이상이여야함)                         */
      //     /* naxKeys:1  state만 가져옴 (state==0이면 에러)                                          */
      //     /* naxKeys:2  state, errorMessage(state==1이면 에러메세지 출력)                            */
      //     /* naxKeys:3  state, errorMessage,mul_no(성공시 결제요청 번호)                             */
      //     /* naxKeys:4  state, errorMessage,mul_no,payurl(결제창URL, URL은 인코딩 되어있음)           */
      //     /*                                                                                    */
      //     /* payurl은 디코딩 시켜서 사용해야 함. 예를들면, urlencode.decode(qObj2.payurl)               */
      //
      //     if(qObj2.state=='0'){
      //       res.send("결제 도중 에러가 발생했습니다. 다시 결제를 진행해 주시기바랍니다.");
      //     } else{
      //
      //       /* DB처리 부분(필요하다면)*/
      //       res.redirect('/payNext');
      //     }
      //   }
      // }
      //
      // request(options, callback);

      /*
      var obj = new Object();
      obj.cmd = "payrequest";
      obj.userid = "ksacademy";
      obj.feedbackurl = "http://tools.frients.io/pg/receivePayApp.do";
      obj.recvphone = phone;
      obj.buyerid = Session.userEmail;
      obj.var2 = Session.userCode;
      obj.price = PlanPrice;
      obj.var1 = "PlanType - " + PlanType;
      obj.goodname = "플랜결제 - Type" + PlanType;

      if(confirm("[" + obj.goodname + "]으로 결제를 진행하시겠습니까?")) {
          AprilUtils.sendServer("https://api.payapp.kr/oapi/apiLoad.html", obj, function(data) {
              // alert("결제 정보가 핸드폰으로 발송되었습니다. 핸드폰에서 결제를 하시면 플랜이 적용됩니다.");
              // document.location.href = "/dashboard.do";
          });
          alert("결제 정보가 핸드폰으로 발송되었습니다. 핸드폰에서 결제를 하시면 플랜이 적용됩니다.");
          document.location.href = "/index.do";
      }
      */
      //
      // PayApp.setParam('userid','ksacademy');
      // PayApp.setParam('shopname','프렌츠아이오');
      // PayApp.setParam('goodname',"플랜결제 - Type" + PlanType);
      // PayApp.setParam('price',PlanPrice);
      // PayApp.setParam('recvphone',phone);
      // PayApp.setParam('reqaddr',1);
      // PayApp.setParam('feedbackurl',"http://tools.frients.io/pg/receivePayApp.do");
      // PayApp.setParam('var1',"PlanType - " + PlanType);
      // PayApp.setParam('var2',Session.userCode);
      // PayApp.setParam('buyerid',Session.userEmail);
      // PayApp.call();
    },
  },
  mounted() {
    let jsScript = document.createElement('script');
    jsScript.setAttribute('src','https://lite.payapp.kr/public/api/payapp-lite.js');
    document.head.appendChild(jsScript)
  },
  created() {
    console.log("payModal. created");


    // var vm = this
    // this.$http.get()
    // .then(function(response){
    //   vm.users = response.data
    // })


  },
  beforeDestroy() {},
};
</script>
